import src from "IMAGE";
export default { src, width: 29, height: 40, blurWidth: 0, blurHeight: 0};
